import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {IWinRatioConfig, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {TimelineLite} from "gsap";
import {DungeonQuestGameConfig, DungeonQuestGameMode} from "../DungeonQuestGameConfig";
import {DungeonQuestSound} from "../DungeonQuestSound";
import {DungeonQuestModeData} from "../server/DungeonQuestModeData";


/**
 * Class description
 *
 * Created: 2017-12-06
 * @author jonas
 */
export class SoundPlayer {

    private _countActive:boolean = true;
    private _activeAnticipationSound:string | null;
    private _currentMusic:string;
    private _bigWinIsPlaying:boolean;

    constructor() {}

    public startCountUp() {
        SlotGame.sound.playEffect(DungeonQuestSound.COUNT_UP_LOOP, -1);
        this._countActive = true;
    }

    public stopCountUp(shouldPlayStopSound:boolean = true) {
        SlotGame.sound.stopEffect(DungeonQuestSound.COUNT_UP_LOOP);
        if(this._countActive && shouldPlayStopSound) {
            SlotGame.sound.playEffect(DungeonQuestSound.COUNT_UP_END);
        }
        this._countActive = false;
    }

    public playNormalWinSound(winRatioConfig:IWinRatioConfig) {
        let soundName:string = "";
        switch(winRatioConfig.type) {
            case WinRatioType.TINY:
                soundName = DungeonQuestSound.TINY_WIN;
                break;
            case WinRatioType.SMALL:
                soundName = DungeonQuestSound.SMALL_WIN;
                break;
            case WinRatioType.MEDIUM:
                soundName = DungeonQuestSound.MEDIUM_WIN;
                break;
            case WinRatioType.LARGE:
                soundName = DungeonQuestSound.LARGE_WIN;
                break;
            default:
                soundName = "";
                break;
        }

        SlotGame.sound.playEffect(soundName);
    }

    public switchToBigWinMusic() {
        if(this._bigWinIsPlaying) {
            return;
        }
        this._bigWinIsPlaying = true;
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => SlotGame.sound.playEffect(DungeonQuestSound.BIG_WIN_SOUND));
    }

    public switchToPreBigWinMusic() {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => SlotGame.sound.stopEffect(DungeonQuestSound.BIG_WIN_SOUND));
        tl.add(() => SlotGame.sound.fadeAmbience(1, 3000));
        this._bigWinIsPlaying = false;
    }

    public switchToFsMusic() {
        if(this._currentMusic == DungeonQuestSound.instance.FREESPIN_AMBIANCE) {
            return;
        }
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => SlotGame.sound.playAmbience(DungeonQuestSound.instance.FREESPIN_AMBIANCE));
        this._currentMusic = DungeonQuestSound.instance.FREESPIN_AMBIANCE;
    }

    public switchToMainMusic() {
        if(this._currentMusic == DungeonQuestSound.instance.MAIN_GAME_AMBIANCE) {
            return;
        }
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => SlotGame.sound.playAmbience(DungeonQuestSound.instance.MAIN_GAME_AMBIANCE));
        this._currentMusic = DungeonQuestSound.instance.MAIN_GAME_AMBIANCE;
    }

    public playTransformExtraLandingSound(reelId:number) {
        let extraLandSound:string = DungeonQuestSound.TRANSFORM_REEL_LANDING_NORMAL;
        if(reelId == 4) {
            extraLandSound = DungeonQuestSound.TRANSFORM_REEL_LANDING_LAST_REEL;
        }

        SlotGame.sound.playEffect(extraLandSound);
    }

    public playTransformSymbolAttention(reelId:number) {
        let transformSound:string = DungeonQuestSound.TRANSFORM_SYMBOL_LAND_ATTENTION_1;
        switch(reelId) {
            case 1:
                transformSound = DungeonQuestSound.TRANSFORM_SYMBOL_LAND_ATTENTION_2;
                break;
            case 2:
                transformSound = DungeonQuestSound.TRANSFORM_SYMBOL_LAND_ATTENTION_3;
                break;
            case 3:
                transformSound = DungeonQuestSound.TRANSFORM_SYMBOL_LAND_ATTENTION_4;
                break;
            case 4:
                transformSound = DungeonQuestSound.TRANSFORM_SYMBOL_LAND_ATTENTION_5;
                break;
            default :
                transformSound = DungeonQuestSound.TRANSFORM_SYMBOL_LAND_ATTENTION_1;
                break;

        }

        SlotGame.sound.playEffect(transformSound);
    }

    public startAnticipationSound(reelId:number):void {
        const transformMode:boolean = DungeonQuestModeData.instance.mode == DungeonQuestGameMode.RANDOM_TRANSFORM || DungeonQuestModeData.instance.mode == DungeonQuestGameMode.FREESPIN;

        if(transformMode) {
            if(reelId == 0) {
                SlotGame.sound.playEffect(DungeonQuestSound.ANTICIPATION_TRANSFORM_RISER);
            }
            SlotGame.sound.playEffect(DungeonQuestSound.ANTICIPATION_TRANSFORM_REEL);

            return;
        }

        if(this._activeAnticipationSound) {
            return;
        }
        this._activeAnticipationSound = DungeonQuestSound.ANTICIPATION_SCATTER;
        SlotGame.sound.playEffect(this._activeAnticipationSound);
    }

    public stopAnticipationSound(reelId:number, quickStop:boolean):void {
        const transformMode:boolean = DungeonQuestModeData.instance.mode == DungeonQuestGameMode.RANDOM_TRANSFORM || DungeonQuestModeData.instance.mode == DungeonQuestGameMode.FREESPIN;

        if(transformMode && (reelId == 4 || quickStop)) {
            SlotGame.sound.stopEffect(DungeonQuestSound.ANTICIPATION_TRANSFORM_REEL);
            SlotGame.sound.stopEffect(DungeonQuestSound.ANTICIPATION_TRANSFORM_RISER);
        }

        if(this._activeAnticipationSound) {
            SlotGame.sound.stopEffect(this._activeAnticipationSound);
            this._activeAnticipationSound = null;
        }
    }

    playWinReelHit(delay:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        // #99
        if (!DungeonQuestGameConfig.instance.WIN_BELOW_STAKE) {
            tl.add(() => SlotGame.sound.playEffect(DungeonQuestSound.WIN_REEL_HIT), delay);
        }
        return tl;
    }


}